import RemoveEndpointsModal from './RemoveEndpointsModal';

export default RemoveEndpointsModal;